module.exports = __webpack_public_path__ + "img/orange-blur.svg";